<template>
  <div class="wrap">
    <!-- <PayHead :mainTitle="'绑定账号'"/> -->
    <div class="bindContent">
      <div class="items">
        <div class="item" v-for="(item,i) in list">
          <div>
            <img :src="item.app_img || require('@/assets/image/mall.png')" alt="">
            <div>
              <p v-text="item.app_name"></p>
              <span v-text="pc_lang.Bind_account + '：' + item.third_user_name" v-show="!!item.third_user_name"></span>
            </div>
          </div>
          <p>
            <!-- <el-button size="mini" type="danger" v-if="item.status" @click="bind(item)">{{pc_lang.Unbind_it}}</el-button>
            <el-button size="mini" type="primary" v-if="!item.status" @click="bind(item)">{{pc_lang.Bind_now}}</el-button> -->
          </p>
        </div>
      </div>
      <el-dialog :title="bindForm.title" :visible.sync="dialogFormVisible" :close-on-click-modal="false" class="bindForm" @close="clearInfo">
        <el-form :model="bindForm":rules="rulesForm" ref="bindForm">
          <el-form-item :label="pc_lang.Username2" prop="username">
            <el-input v-model="bindForm.username" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item :label="pc_lang.Password" prop="password">
            <el-input type="password" v-model="bindForm.password" autocomplete="off" @keyup.13.native="submit"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="medium">{{pc_lang.Cancel}}</el-button>
          <el-button type="primary" size="medium" @click="submit">{{pc_lang.Confirm}}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import PayHead from '@/components/PayHead'
import * as API_INDEX from '@/api/index'
import * as API_USER from '@/api/user'

export default {
  name: 'Bind',
  components: {
    PayHead
  },
  data() {
    return {
      // 账号表单
      dialogFormVisible: false,
      bindForm: {
        to: '',
        title: '',
        username: '',
        password: '',
        appNo: '',
      },
      list: []
    }
  },
  computed: {
    rulesForm() {
      return {
        username: [
          { required: true, message: this.pc_lang.Please_enter_username, trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.pc_lang.Enter_the_password, trigger: 'blur' }
        ]
      }
    }
  },
  async mounted() {

  },
  created() {
    this.getBindList().then(()=>{
      this.encryptionUsername()
    })
  },
  methods: {
    // 用户名加密显示
    encryptionUsername() {
      let arr = this.list
      return arr.map(obj=> {
        if (obj.third_user_name) {
          obj.third_user_name = obj.third_user_name.substr(0,2) + '*******' + obj.third_user_name.substr(obj.third_user_name.length - 2)
        }
        return obj
      })
    },
    // 清除dialog信息
    clearInfo() {
      this.bindForm = {
        to: '',
        title: '',
        username: '',
        password: '',
        appNo: ''
      }
    },
    // 绑定，解绑
    bind(item) {
      this.bindForm = {
        to: item.app_name,
        title: item.status ? this.pc_lang.Unbind_account : this.pc_lang.Account_binding,
        username: '',
        password: '',
        appNo: item.app_no,
      }
      this.dialogFormVisible = true
    },
    // 提交dialog
    submit() {
      let item = this.list.filter(obj=> {
        return obj.app_name == this.bindForm.to
      })[0]
      if (item.status) {
        /* 解绑 */
        this.unBind().then(res=> {
          this.getBindList().then(()=> this.encryptionUsername())
          this.dialogFormVisible = false
          this.clearInfo()
          this.$message({
            // message: error.response.data.message,
            message: this.pc_lang.Successful_operate,
            type: 'success',
            duration: 5 * 1000
          })
        },rej=> {
          this.$message({
            // message: error.response.data.message,
            message: rej.msg,
            type: 'error',
            duration: 5 * 1000
          })
        })
      } else {
        /* 绑定 */
        this.userBind().then(res=> {
          this.getBindList().then(()=> this.encryptionUsername())
          this.dialogFormVisible = false
          this.clearInfo()
          this.$message({
            // message: error.response.data.message,
            message: this.pc_lang.Successful_operate,
            type: 'success',
            duration: 5 * 1000
          })
        },rej=> {
          this.$message({
            // message: error.response.data.message,
            message: rej.msg,
            type: 'error',
            duration: 5 * 1000
          })
        })
      }
    },
    /* 获取绑定 */
    getBindList() {
      return new Promise((resolve, reject)=> {
        API_INDEX.bindList().then(res=> {
          this.list = res.data
          resolve()
        },rej=> {
          reject()
        })
      })
    },
    /* 绑定 */
    userBind() {
      return new Promise((resolve, reject)=> {
        let params = JSON.parse(JSON.stringify(this.bindForm))
        params.password = md5(params.password)
        API_USER.userBind(params).then(res=> {
          resolve(res)
        },rej=> {
          reject(rej)
        })
      })
    },
    /* 解除绑定 */
    unBind() {
      return new Promise((resolve, reject)=> {
        let params = JSON.parse(JSON.stringify(this.bindForm))
        params.password = md5(params.password)
        API_USER.unBind(params).then(res=> {
          resolve(res)
        },rej=> {
          reject(rej)
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>

.bindContent{
  .items{
    margin: 20px 0;
    .item{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 0;
      border-bottom: $border;
      >div{
        display: flex;
        align-items: center;
        img{
          width: 48px;
          height: 48px;
          margin-right: 12px;
        }
        >div{
          p{
            font-size: 18px;
            color: #888;
            margin-bottom: 4px;
          }
          span{
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
  .bindForm{
    .el-dialog__body{
      padding: 20px;
    }
    .el-dialog{
      width: 600px;
    }
    .el-form-item{
      margin-bottom: 14px;
    }
  }
</style>